const _dynamic_base = window._dynamic_base;
if (!_dynamic_base){
    console.warn('_dynamic_base is not defined');
}

export { _dynamic_base }
